export const STORAGE_PREFIX = '__pmtr';
